
function Loader(){
    return(
        <div className="loader-body">
            <div className="loader"></div>
            <div>Waiting for server to load...</div>
        </div>
    )
}

export default Loader;